module.exports = require("@swa-ui/core/src/FadingDot/FadingDot.module.scss");